import './slider-carousel.scss';
import React, { useEffect, useRef, useState } from 'react';
import ImageGenerator from '../../image-generator/image-generator';
import { Link, useHistory } from 'react-router-dom';
import Slider from 'react-slick-pnth';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import play from '../../../assets/images/Group 106.svg'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { render_object_type } from '../../../shared/services/general/configs';

const NextArrow = (props) => {
	const { className, onClick } = props;
	return (
		<div className={className} onClick={onClick}>
			<ChevronRightIcon style={{ fontSize: "30px", color: "white" }} />
		</div>
	);
};

const PrevArrow = (props) => {
	const { className, onClick } = props;
	return (
		<div className={className} onClick={onClick}>
			<ChevronLeftIcon style={{ fontSize: "30px", color: "white" }} />
		</div>
	);
};

function SliderCarousel({ data, baseUrl }) {
	const [isDragging, setIsDragging] = useState(false);
	const history = useHistory();
	const startX = useRef(0);
	const startY = useRef(0);

	const handleMouseDown = (e) => {
		startX.current = e.clientX;
		startY.current = e.clientY;
		setIsDragging(true);
	};

	const handleMouseUp = () => {
		setTimeout(() => setIsDragging(false), 50); // کمی تاخیر برای اطمینان از اتمام درگ
	};

	useEffect(() => {
		window.addEventListener('mouseup', handleMouseUp);
		return () => {
			window.removeEventListener('mouseup', handleMouseUp);
		};
	}, []);

	const handleClick = (e, url) => {
		const dx = Math.abs(e.clientX - startX.current);
		const dy = Math.abs(e.clientY - startY.current);
		const distance = Math.sqrt(dx * dx + dy * dy);

		if (distance < 5) {
			history.push(url);
		} else {
			e.preventDefault();
			e.stopPropagation();
		}
	};

	const onFindLastItem = () => {
		const elementsWithClassName = document.querySelectorAll('.last-current-item');
		elementsWithClassName.forEach(element => {
			element.classList.remove('last-current-item');
		});

		const slickActiveElements = document.querySelectorAll('.slider-carousel .slick-slide.slick-active');
		const lastSlickActive = slickActiveElements[slickActiveElements.length - 2];
		if (lastSlickActive) {
			lastSlickActive.classList.add('last-current-item');
		}
	};

	const handleChange = (current) => {
		if (isDragging) return;

		const centerSlide = document.querySelector('.slick-center.slick-current');

		if (centerSlide) {
			const prevSlide = centerSlide.previousElementSibling;
			const nextSlide = centerSlide.nextElementSibling;

			document.querySelectorAll('.slick-slide').forEach(slide => {
				slide.classList.remove('is-prev', 'is-next');
			});

			if (prevSlide?.classList.contains('slick-slide')) {
				prevSlide.classList.add('is-prev');
			}

			if (nextSlide?.classList.contains('slick-slide')) {
				nextSlide.classList.add('is-next');
			}
		}

		onFindLastItem?.();
	};

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		rtl: true,
		className: "center",
		// centerMode: true,
		centerPadding: "12px",
		// autoplay: true,
		autoplaySpeed: 8000,
		adaptiveHeight: true,
		initialSlide: 0,
		currentSlide: 0,
		nextArrow: <PrevArrow className="slick-arrow slick-next"/>,
		prevArrow: <NextArrow className="slick-arrow slick-prev"/>,
		onReInit: handleChange,
		afterChange: handleChange,
		responsive: [
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "20px",
					arrows: false,
					dots: true,
				},
			},
			{
				breakpoint: 680,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "20%",
					arrows: false,
					dots: true,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "20%",
					arrows: false,
					dots: true,
				},
			},
		],
	};

	const sliderData = data.programs || data.objects;

	const getTypeProgram = (type) => {
		if (!type) return baseUrl;
		if (type === 'MOVIE') return 'movies';
		if (type === 'SERIES') return 'series';
	};

	return (
		<>
			{sliderData && sliderData.length > 0 && (
				<div className="slider-carousel">
					<div className="slider-container">
						<Slider {...settings}>
							{sliderData.map((item, index) => (
								<Link className='play'
									to={`/${getTypeProgram(item?.type)}/${item.programId || item.id}`}
									key={index}
									onMouseDown={handleMouseDown}
									onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleClick(e, `/${getTypeProgram(item?.type)}/${item.programId || item.id}`); }}
								>
									{item?.type === render_object_type.series && (
										<div className="effect-poster">
											<ImageGenerator src={item.image} name={item.title} />
											<ImageGenerator src={item.image} name={item.title} />
										</div>
									)}
									<div className='gradient-overly'>
										<span className='play'>
											<ImageGenerator src={play} />
										</span>
										<ImageGenerator src={item?.image} isLazy={false} name={''} />
										<div className="movie-info">
											<div>
												<div className="title">{item?.title}</div>
											</div>
										</div>
									</div>
								</Link>
							))}
						</Slider>
					</div>
				</div>
			)}
		</>
	);
}

export default SliderCarousel;
